export type UserVerificationDto = {
	confirmationCode: string;
	password: string;
};

export const defaultUserVerificationDto = (): UserVerificationDto => {
	return {
		confirmationCode: '',
		password: '',
	};
};
